import request from '@utils/request';

const PREFIX = '[ORDER]';

export const FETCH_ORDERS_REQUEST = `${PREFIX} FETCH_ORDERS_REQUEST`;
export const FETCH_ORDERS_SUCCESS = `${PREFIX} FETCH_ORDERS_SUCCESS`;
export const FETCH_ORDERS_FAILURE = `${PREFIX} FETCH_ORDERS_FAILURE`;

export const fetchOrdersRequest = () => ({
  type: FETCH_ORDERS_REQUEST,
});

export const fetchOrdersSuccess = (payload) => ({
  type: FETCH_ORDERS_SUCCESS,
  payload,
});

export const fetchOrdersFailure = () => ({
  type: FETCH_ORDERS_FAILURE,
});

export const fetchOrders = (propertyId, guestId, headers) => (dispatch) => {
  dispatch(fetchOrdersRequest());
  return request
    .get(`${propertyId}/guests/${guestId}/orders`, { params: { perPage: 0 }, ...headers })
    .then(
      ({ data }) => dispatch(fetchOrdersSuccess(data.data)),
      (error) => {
        dispatch(fetchOrdersFailure(error));
      }
    );
};

export const FETCH_ORDER_REQUEST = `${PREFIX} FETCH_ORDER_REQUEST`;
export const FETCH_ORDER_SUCCESS = `${PREFIX} FETCH_ORDER_SUCCESS`;
export const FETCH_ORDER_FAILURE = `${PREFIX} FETCH_ORDER_FAILURE`;

export const fetchOrderRequest = () => ({
  type: FETCH_ORDER_REQUEST,
});

export const fetchOrderSuccess = (payload) => ({
  type: FETCH_ORDER_SUCCESS,
  payload,
});

export const fetchOrderFailure = () => ({
  type: FETCH_ORDER_FAILURE,
});

export const fetchOrder = (propertyId, guestId, orderId) => (dispatch) => {
  dispatch(fetchOrderRequest());
  return request.get(`${propertyId}/guests/${guestId}/orders/${orderId}`).then(
    ({ data }) => dispatch(fetchOrderSuccess(data)),
    (error) => {
      dispatch(fetchOrderFailure(error));
    }
  );
};
